// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop_Backdrop__3j6VK","backdrop":"Backdrop_backdrop__3aIp6"};